module.exports = __webpack_public_path__ + "media/images/favicons/favicon-96x96-e1b274a8716b6400752038fa570a81ad.png";